import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { useParams } from "react-router-dom";
import ViewEsimBookingLayer from "./ViewEsimBookingLayer";

const ViewEsimBookingPage = () => {
  const { id } = useParams("id");

  return (
    <MasterLayout>
      <Breadcrumb title="eSIM Booking View" />
      <ViewEsimBookingLayer id={id} />
    </MasterLayout>
  );
};

export default ViewEsimBookingPage;
